import { ResourceCategory } from './../builders/resource_category_builder';
import { IDatasourceOptions, key } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';

interface IResourceCategoriesDatasourceModel {
  selected: key;
}

export interface IResourceCategoriesDatasource extends IDatasource<ResourceCategory> {
  model: IResourceCategoriesDatasourceModel;
}

angular
  .module('capability-ng-resources')
  .factory('ngResourceCategoriesDatasource', function(
    ngResourceCategoryBuilder: typeof ResourceCategory,
    Datasource: IDatasourceConstructor<ResourceCategory>
  ): IResourceCategoriesDatasource {
    return new Datasource<ResourceCategory, IResourceCategoriesDatasourceModel>({
      builderType: ngResourceCategoryBuilder
    }).includeModel({
      selected: 0
    });
  });



// WEBPACK FOOTER //
// ./app/lib/resources/datasources/resource_categories_datasource.ts